export default {"src":"/_next/static/media/shoppingCart_24.1ab30bb5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};